module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/contact icon-3c00d32d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/contact icon.svg
// module id = ./app/web/src/assets/contact icon.svg
// module chunks = 0